import React, { ReactNode } from 'react';

const Title = ({children}: { children: ReactNode }) => {
  return <div className="text-lg md:text-xl lg:text-2xl xl:text-3xl font-medium my-2 md:my-3 lg:my-4">{children}</div>;
};

export default Title;
